// Shared domain constants

export const ROLES = {
  MAIN: "main_manager",
  RESTAURANT: "restaurant_manager",
  EMPLOYEE: "employee",
};

export const ROLE_LABEL = {
  main_manager: "Main Manager",
  restaurant_manager: "Restaurant Manager",
  employee: "Employee",
};

export const RESTAURANTS = [
  { id: "restaurant_1", name: "Spring Mountain", brand: "Café Breizh" },
  { id: "restaurant_2", name: "Henderson", brand: "Café Breizh" },
];

export const RESTAURANT_BY_ID = Object.fromEntries(
  RESTAURANTS.map((r) => [r.id, r])
);

export const AREAS = [
  { id: "kitchen", name: "Kitchen" },
  { id: "bakery", name: "Bakery" },
  { id: "pastry", name: "Pastry" },
  { id: "coffee_bar", name: "Coffee Bar" },
  { id: "cleaning", name: "Cleaning" },
];

export const AREA_BY_ID = Object.fromEntries(AREAS.map((a) => [a.id, a]));

export const REQUEST_TYPES = {
  PURCHASE: "purchase",
  TRANSFER: "internal_transfer",
};

export const REQUEST_STATUS = {
  DRAFT: "draft",
  SUBMITTED: "submitted",
  APPROVED: "approved",
  REJECTED: "rejected",
  COMPLETED: "completed",
};

export const STATUS_LABEL = {
  draft: "Draft",
  submitted: "Submitted",
  approved: "Approved",
  rejected: "Rejected",
  completed: "Completed",
};

// UI tone per status
export const STATUS_TONE = {
  draft: "muted",
  submitted: "pending",
  approved: "success",
  rejected: "danger",
  completed: "success",
};

export const CATEGORIES = [
  "Dairy",
  "Produce",
  "Bakery",
  "Dry Goods",
  "Beverages",
  "Paper & Disposables",
  "Cleaning",
  "Meat & Deli",
];
